import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { Card, Row, Col, Image, Alert, Badge } from 'react-bootstrap';

/* ---- Month data -------------------------------------------------- */
const monthData = [
    { m: 'Jan', ed: 26.60, em: 825, hd: 1.20, hm: 37.1 },
    { m: 'Feb', ed: 48.90, em: 1370, hd: 2.26, hm: 63.2 },
    { m: 'Mrz', ed: 77.00, em: 2390, hd: 3.69, hm: 114 },
    { m: 'Apr', ed: 97.50, em: 2930, hd: 4.86, hm: 146 },
    { m: 'Mai', ed: 95.50, em: 2960, hd: 4.87, hm: 151 },
    { m: 'Jun', ed: 97.80, em: 2930, hd: 5.07, hm: 152 },
    { m: 'Jul', ed: 94.60, em: 2930, hd: 4.95, hm: 154 },
    { m: 'Aug', ed: 91.20, em: 2830, hd: 4.73, hm: 147 },
    { m: 'Sep', ed: 80.50, em: 2410, hd: 4.07, hm: 122 },
    { m: 'Okt', ed: 58.90, em: 1820, hd: 2.87, hm: 88.9 },
    { m: 'Nov', ed: 32.40, em: 973, hd: 1.51, hm: 45.2 },
    { m: 'Dez', ed: 22.60, em: 702, hd: 1.02, hm: 31.5 },
];

const sumEd = (monthData.reduce((s, r) => s + r.ed, 0)).toFixed(0);
const sumEm = (monthData.reduce((s, r) => s + r.em, 0)).toFixed(0);
const sumHd = (monthData.reduce((s, r) => s + r.hd, 0) / monthData.length).toFixed(2);
const sumHm = (monthData.reduce((s, r) => s + r.hm, 0)).toFixed(0);

const images = [
    { src: 'https://tiefel.mehl-web.de/img/pv/pv1.png', alt: 'PV-Modul Übersicht 1' },
    { src: 'https://tiefel.mehl-web.de/img/pv/pv2.png', alt: 'PV-Modul Übersicht 2' },
    { src: 'https://tiefel.mehl-web.de/img/pv/pv3.png', alt: 'PV-Modul Übersicht 3' },
    { src: 'https://tiefel.mehl-web.de/img/pv/wechselrichter_module_schaltung.jpg', alt: 'Wechselrichter-Schaltung' },
];

const Anlage = props => (
    <div className="anlage-page">
        {/* ---- Page Header ------------------------------------------ */}
        <div className="page-header-row mb-4">
            <div className="d-flex align-items-center gap-3">
                <div className="header-icon-circle">
                    <i className="bi bi-solar-panel" />
                </div>
                <div>
                    <h2 className="mb-1">Anlage</h2>
                    <p className="mb-0 small op-75">
                        PVGIS-Schätzung der Solarenergieproduktion
                    </p>
                </div>
            </div>
        </div>

        {/* ---- System-Spec Stat Cards -------------------------------- */}
        <Row xs={1} sm={2} lg={4} className="mb-4 g-3">
            {[
                { icon: 'bi-lightning-charge-fill', label: 'Nennleistung', value: '27,5', unit: 'kW', color: 'power' },
                { icon: 'bi-arrow-down-up', label: 'Neigung', value: '48°', unit: '', color: 'energy' },
                { icon: 'bi-compass-fill', label: 'Azimuth', value: '192°', unit: '', color: 'consumption' },
                { icon: 'bi-percent', label: 'Gesamtverluste', value: '26,8', unit: '%', color: 'specific' },
            ].map((item) => (
                <Col key={item.label}>
                    <div className={`stat-card ${item.color}`}>
                        <div className={`stat-card-icon bi ${item.icon}`} />
                        <div className="stat-card-content">
                            <div className="stat-card-value">
                                {item.value}
                                {item.unit && <span className="stat-card-unit">{item.unit}</span>}
                            </div>
                            <div className="stat-card-label">{item.label}</div>
                        </div>
                    </div>
                </Col>
            ))}
        </Row>

        {/* ---- Detail Cards Row -------------------------------------- */}
        <Row className="mb-4 g-3">
            {/* Losses Breakdown Card */}
            <Col lg={5}>
                <Card className="h-100">
                    <Card.Header>
                        <i className="bi bi-info-circle me-2" />
                        Verlustaufschlüsselung
                    </Card.Header>
                    <Card.Body>
                        {[
                            { label: 'Temperatur + niedrige Einstrahlung', value: '12,4%', detail: 'mit Einfluss der lokalen Außentemperatur' },
                            { label: 'Reflexionseffekte', value: '2,9%', detail: '' },
                            { label: 'Kabel, Inverter usw.', value: '14,0%', detail: 'Andere Verluste' },
                        ].map((item) => (
                            <div className="loss-item" key={item.label}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <span className="loss-label">{item.label}</span>
                                    <Badge bg="secondary-text" className="loss-value">{item.value}</Badge>
                                </div>
                                {item.detail && <small className="op-75">{item.detail}</small>}
                            </div>
                        ))}
                    </Card.Body>
                </Card>
            </Col>

            {/* Sun Radiation DB Card */}
            <Col lg={4}>
                <Card className="h-100">
                    <Card.Header>
                        <i className="bi bi-database me-2" />
                        Strahlungsdatenbank
                    </Card.Header>
                    <Card.Body>
                        <div className="info-box mb-3">
                            <i className="bi bi-sun me-2" />
                            <strong>PVGIS-CMSAF</strong>
                            <br />
                            <small>Kristallin Silizium · Festes System</small>
                        </div>
                        <div className="info-box">
                            <i className="bi bi-info-circle me-2" />
                            <strong>PVGIS System Loss: 14%</strong>
                            <br />
                            <small>
                                Standardwert für alle Verluste vom Modul zum Netz:&nbsp;
                                Kabel, Inverter, Verschmutzung (evtl. Schnee),
                                sowie jahreszeitliche Alterung der Module.
                                Bei bekanntem abweichen­dem Wert anpassbar.
                            </small>
                        </div>
                    </Card.Body>
                </Card>
            </Col>

            {/* Quick Summary Card */}
            <Col lg={3}>
                <Card className="h-100">
                    <Card.Header>
                        <i className="bi bi-calculator me-2" />
                        Jahres-Zusammenfassung
                    </Card.Header>
                    <Card.Body>
                        <div className="summary-item">
                            <span className="summary-label">Tagesdurchschnitt</span>
                            <span className="summary-value">{sumEd} <small>kWh</small></span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Monatsdurchschnitt</span>
                            <span className="summary-value">{sumEm} <small>kWh</small></span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Einstrahlung (tag)</span>
                            <span className="summary-value">{sumHd} <small>kWh/m²</small></span>
                        </div>
                        <div className="summary-item">
                            <span className="summary-label">Einstrahlung (monat)</span>
                            <span className="summary-value">{sumHm} <small>kWh/m²</small></span>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>

        {/* ---- Monthly Production Table ------------------------------ */}
        <Card className="mb-4">
            <Card.Header>
                <i className="bi bi-table me-2" />
                Monatliche Ertragsdaten
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <table className="anlage-table mb-0">
                        <thead>
                            <tr>
                                <th>Monat</th>
                                <th>E<sub>d</sub> (kWh)</th>
                                <th>E<sub>m</sub> (kWh)</th>
                                <th>H<sub>d</sub> (kWh/m²)</th>
                                <th>H<sub>m</sub> (kWh/m²)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {monthData.map((row) => (
                                <tr key={row.m}>
                                    <td className="month-cell">{row.m}</td>
                                    <td align="right">{row.ed.toFixed(2)}</td>
                                    <td align="right">{row.em}</td>
                                    <td align="right">{row.hd.toFixed(2)}</td>
                                    <td align="right">{row.hm}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="table-total">
                                <td><strong>Jahresgesamt</strong></td>
                                <td align="right"><strong>{sumEd}</strong></td>
                                <td align="right"><strong>{sumEm}</strong></td>
                                <td align="right"><strong>{sumHd}</strong></td>
                                <td align="right"><strong>{sumHm}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </Card.Body>
        </Card>

        {/* ---- Legend ----------------------------------------------- */}
        <div className="mb-4 anlage-legend">
            <h6><i className="bi bi-question-circle me-2" />Spaltenerklärung</h6>
            <div className="row">
                <div className="col-sm-6 mb-2">
                    <strong>E<sub>d</sub></strong> — Durchschnittliche tägliche Energieproduktion (kWh)
                </div>
                <div className="col-sm-6 mb-2">
                    <strong>E<sub>m</sub></strong> — Durchschnittliche monatliche Produktion (kWh)
                </div>
                <div className="col-sm-6 mb-2">
                    <strong>H<sub>d</sub></strong> — Tägliche Einstrahlung pro m² auf den Modulen (kWh/m²)
                </div>
                <div className="col-sm-6 mb-2">
                    <strong>H<sub>m</sub></strong> — Monatliche Einstrahlungssumme pro m² (kWh/m²)
                </div>
            </div>
        </div>

        {/* ---- Image Gallery ----------------------------------------- */}
        <h4 className="section-heading-anlage mb-3">
            <i className="bi bi-images me-2" />Anlagenfotos
        </h4>
        <Row xs={1} sm={2} className="g-3 mb-4">
            {images.map((img) => (
                <Col key={img.src}>
                    <Card className="gallery-card">
                        <Card.Body className="p-2">
                            <Image src={img.src} alt={img.alt} fluid className="gallery-image" />
                        </Card.Body>
                        <Card.Footer className="small op-75">
                            <i className="bi bi-image me-1" />{img.alt}
                        </Card.Footer>
                    </Card>
                </Col>
            ))}
        </Row>
    </div>
);

export default connect(
    state => state.counter,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Anlage);
